export const walk = (input, key, callbackFn) => {
  if (Array.isArray(input)) {
    input.forEach((item) => walk(item, key, callbackFn));
    return;
  }

  if (typeof input === 'object' && input !== null) {
    callbackFn(input);

    if (Array.isArray(input[key]) && input[key].length > 0) {
      walk(input[key], key, callbackFn);
    }
  }
};
